var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'carousel-root',
    _vm.isExpanded && 'carousel-root-expand',
    _vm.isVertical && 'vertical'
    ]},[_c('div',{staticClass:"pages"},[_vm._t("default")],2),_vm._v(" "),(!_vm.isVertical)?_c('div',{class:[
        'inner-carousel',
        _vm.isExpanded ? "inner-carousel-expanded":''
        ]},[_c('div',{staticClass:"indicators"},_vm._l((4),function(index){return _c('div',{key:("indicator-" + index),class:[
                    "indicator",
                    index-1 == _vm.activeIndex ? 'indicator-active' : ''
                ]})}))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a9c782e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Home/Carousel.vue
// module id = null
// module chunks = 